import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  icon: {
    fill: ({ theme }: ThemeFunction<unknown>) => theme.textColor,
    stroke: ({ theme }: ThemeFunction<unknown>) => theme.textColor,
  },
};
